import { render, staticRenderFns } from "./SelectionConfigModal.vue?vue&type=template&id=4bb49650&scoped=true&"
import script from "./SelectionConfigModal.vue?vue&type=script&lang=js&"
export * from "./SelectionConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectionConfigModal.vue?vue&type=style&index=0&id=4bb49650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb49650",
  null
  
)

export default component.exports